<template>
  <div class="device-drinks">
    <el-row class="device-drink-title">
      <el-col :span="3">
        <span class="h3">{{ $t('she_bei_yin_pin') }}</span>
        <router-back />
      </el-col>
    </el-row>
    <el-row class="device-drink-info">
      <el-col :span="14" class="device-info">
        <p>
          <label>{{ $t('she_bei_ming_cheng') }}:</label> <span>{{ device.name }}</span> <span
            class="mini">({{ device.uuid }})</span>

        </p>
        <p><label>{{ $t('chan_pin_ming_cheng') }}:</label> <span>{{ device.productName }}</span></p>
        <p><label>{{ $t('she_bei_wei_zhi') }}:</label>
          <span
            v-if="device.province && device.province.length != 0">{{ device.province }}/{{ device.city }}/{{ device.address }}</span>
          <span v-else>{{ $t('zan_wei_she_zhi_de_li_wei_zhi') }}</span>
        </p>
      </el-col>
      <el-col :span="10" class="device-operate btn">
        <!-- <el-button class="warn" size="mini" @click="fullPullDrinkSync">{{ $t('tong_bu_she_bei_yin_pin_pei_fang') }}
        </el-button> -->
        <el-button class="warn" size="mini" @click="fullPullDevice">{{ $t('la_qu_she_bei_yin_pin') }}</el-button>
        <!--<el-button class="warn" size="mini" @click="showCreateDrink">自定义新增</el-button>-->
        <el-button class="error" size="mini" @click="syncDevice">{{ $t('she_bei_yin_pin_geng_xin') }}</el-button>
      </el-col>
    </el-row>
    <div class="device-drink-data-list">
      <el-table :data="drinks">
        <el-table-column align="center">
          <template slot-scope="scope">
            <div class="drink-item-info">
              <img :src="scope.row.img">
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('yin_pin_xin_xi')" align="center" min-width="160">
          <template slot-scope="scope">
            <div class="drink-item-info">
              <span>{{ scope.row.name }} / {{ scope.row.engName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('xiao_bei_jia_ge_yuan')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.price | F1000 }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('zhong_bei_jia_ge_yuan')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.middlePrice | F1000 }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('da_bei_jia_ge_yuan')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.bigPrice | F1000 }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('geng_xin_shi_jian')" align="center">
          <template slot-scope="scope">
            <span>{{ new Date(scope.row.updateAt * 1000).Format('yyyy-MM-dd hh:mm:ss') }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('pai_xu_yue_xiao_yue_kao_qian')" align="center" prop="orderCond"></el-table-column>
        <el-table-column :label="$t('cao_zuo')" align="center" prop="name">
          <template slot-scope="scope">
            <span @click="handleEdit(scope.row)" class="device-drink-edit">{{ $t('bian_ji') }}</span>

          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination @current-change="handleCurrentChange" class="pagination" :current-page="pagination.curPage"
      :page-size="pagination.limit" layout="total, prev, pager, next, jumper" :total="pagination.total">
    </el-pagination>


    <c-dialog :visible.sync="editCoffeeVisible" class="cup-dialog" :title="$t('bian_ji_yin_pin')" :width="'42rem'"
      :height="'28rem'">
      <el-button slot="title" size="mini" type="primary" @click="saveCoffeeEdit">{{ $t('bao_cun') }}</el-button>
      <div class="check">
        <el-row :gutter="20">
          <el-col :span="11">
            <upload :url="drink.img"></upload>
          </el-col>
          <el-col :span="12">
            <el-form label-width="120px" size="mini">
              <el-form-item :label="$t('yin_pin_ming_cheng')">
                <el-input v-model="drink.name" :placeholder="$t('qing_shu_ru_yin_pin_ming_cheng')" />
              </el-form-item>
              <el-form-item :label="$t('yin_pin_ying_wen_ming_cheng')">
                <el-input v-model="drink.engName" :placeholder="$t('qing_shu_ru_yin_pin_ying_wen_ming_cheng')" />
              </el-form-item>
              <el-form-item :label="$t('xiao_bei_jia_ge')">
                <el-input @input="limitInput($event, 'drink.price')" v-model.trim="drink.price" type="number"
                  :placeholder="$t('dan_wei_wei_yuan')" />
              </el-form-item>

              <el-form-item :label="$t('zhong_bei_jia_ge')">
                <el-input @input="limitInput($event, 'drink.middlePrice')" v-model.trim="drink.middlePrice" type="number"
                  :placeholder="$t('dan_wei_wei_yuan')" />
              </el-form-item>
              <el-form-item :label="$t('da_bei_jia_ge')">
                <el-input @input="limitInput($event, 'drink.bigPrice')" v-model.trim="drink.bigPrice" type="number"
                  :placeholder="$t('dan_wei_wei_yuan')" />
              </el-form-item>
              <el-form-item :label="$t('pai_xu_wei_zhi')">
                <el-input size="mini" v-model.number="drink.orderCond" :placeholder="$t('yue_xiao_yue_kao_qian')">
                </el-input>
              </el-form-item>


            </el-form>
          </el-col>
        </el-row>
      </div>
    </c-dialog>
    <loading :show="showLoading" />
  </div>

</template>

<script>
import {
  drinkDeviceUnion, drinkDeviceList, drinkDeviceCreate, drinkDeviceUpdate,
  drinkSortSample, drinkDeviceSortCreate, deviceSyncDrink, deviceFullPull, deviceDrinkMaterialFullPull
} from '@/api/delivery/device/drink'
import CDialog from '@/components/Dialog'
import Upload from '@/components/Upload'
import Loading from '@/components/Loading'

export default {
  name: '',
  components: {
    CDialog,
    Upload,
    Loading
  },
  activated: function () {
    this.device = this.$route.params
    this.pagination.deviceUuid = this.device.uuid
    this.loadDrinks()
  },
  data: function () {
    return {
      device: {
        name: '测试设备'
      },
      drinkStoreVisible: false,
      selfConfVisible: false,
      editCoffeeVisible: false,
      showLoading: false,
      drinkSort: {
        uuids: [],
        price: 0,
        deviceUuid: '',
      },
      drinks: [],
      drinkTmpls: [],
      pagination: {
        deviceUuid: '',
        start: 0,
        curPage: 1,
        limit: 5,
        total: 0,
      },
      drink: {},

    }
  },

  methods: {
    limitInput(value, name) {
      let val = (value && value.split("")) || [];
      let reg1 = /\d/;
      let reg2 = /\./;
      // 第一个字符不能为小数点
      if (val[0] == ".") {
        this.form[name] = "";
        return;
      }
      // 过滤掉除数字和小数点外的字符
      val = str.filter((e) => reg1.test(e) || reg2.test(e));
      // 匹配小数点后只能有两位小数
      // 解释一下这个match正则规格
      // ^\d* 是指以数字开头，后面允许输入0到多位数字
      // (\.?) 是指只允许一个小数点
      // \d{0,2} 是指只允许0到2位小数
      this.form[name] = val.join("").match(/^\d*(\.?\d{0,2})/g)[0] || null;
    },
    materielExtraCostChange(item) {
      // 防止删除为空
      if (!item) {
        item = '0.00'
      }
      // 一些错误金额输入的判断
      if (item.toString().indexOf('.') > 0 && Number(item.toString().split('.')[1].length) < 1) {
        item = item.toString().split('.')[0]
      }
      // 一些错误金额输入的判断
      if (!item || item === '-' || item === '-0') {
        item = '0.00'
      }
      return parseFloat(item).toFixed(2)

    },

    handleCurrentChange(value) {
      this.pagination.curPage = value
      this.pagination.start = (value - 1) * this.pagination.limit
      drinkDeviceList(this.pagination).then(res => {
        this.drinks = this.transPrice(res.data)
      })
    },
    transPrice(data) {
      for (let i = 0; i < data.length; i++) {
        data[i].price = data[i].price / 100
        data[i].middlePrice = data[i].middlePrice / 100
        data[i].bigPrice = data[i].bigPrice / 100
      }
      return data
    },
    loadDrinks() {
      drinkDeviceUnion(this.pagination).then(res => {
        this.drinks = this.transPrice(res.data.list || [])

        this.pagination.total = parseInt(res.data.total)
      })
    },
    loadDrinkStore() {
      drinkSortSample().then(res => {
        this.drinkTmpls = res.data || []
        this.drinkStoreVisible = true
      })
    },

    saveDrinkSort() {
      this.drinkSort.price *= 100
      this.drinkSort.deviceUuid = this.pagination.deviceUuid
      drinkDeviceSortCreate(this.drinkSort).then(() => {
        this.drinkSort.price = 0
        this.drinkStoreVisible = false
        this.loadDrinks()
      })
    },

    showCreateDrink() {
      this.coffee = {
        deviceUuid: this.device.uuid,
        name: '',
        img: 'test',
        price: 0,
        grind: 0,
        preRush: 0,
        coffee: 0,
        milk: 0,
        foam: 0,
        water: 0,
        orderCond: 0,
      }
      this.selfConfVisible = true
    },

    handleCreateDrink() {
      if (this.coffee.img.length === 0) {
        this.$message.warning(this.$t('qing_xian_shang_chuan_yin_pin_tu_pian'))
        return
      }
      this.coffee.price = this.strip(this.coffee.price * 100)

      if (this.coffee.name.length === 0) {
        this.$message.warning(this.$t('qing_shu_ru_yin_pin_ming_cheng'))
        return
      }

      drinkDeviceCreate(this.coffee).then(() => {
        this.selfConfVisible = false
        this.$message.success(this.$t('tian_jia_cheng_gong'))
        this.loadDrinks()
      })
    },
    handleEdit(item) {
      this.drink = {
        uuid: item.uuid,
        deviceUuid: this.pagination.deviceUuid,
        name: item.name,
        img: item.img,
        price: item.price,
        middlePrice: item.middlePrice,
        bigPrice: item.bigPrice,
        engName: item.engName,
        orderCond: item.orderCond,
      }
      this.editCoffeeVisible = true
    },

    strip(num, precision = 12) {
      return +parseFloat(num.toPrecision(precision));
    },

    saveCoffeeEdit() {
      this.drink.price = this.strip(parseFloat(this.drink.price) * 100)
      this.drink.middlePrice = this.strip(parseFloat(this.drink.middlePrice) * 100)
      this.drink.bigPrice = this.strip(parseFloat(this.drink.bigPrice) * 100)

      if (this.drink.name.length === 0) {
        this.$message.warning(this.$t('qing_shu_ru_yin_pin_ming_cheng'))
        return
      }
      if (this.drink.engName.length === 0) {
        this.$message.warning(this.$t('qing_shu_ru_yin_pin_ying_wen_ming_cheng'))
        return
      }

      drinkDeviceUpdate(this.drink).then(() => {
        this.editCoffeeVisible = false
        this.handleCurrentChange(this.pagination.curPage)
        this.$message.success(this.$t('bian_ji_cheng_gong'))
      })
    },


    syncDevice() {
      this.$confirm(this.$t('ci_cao_zuo_jiang_tong_bu_yin_pin_zhi_she_bei'), this.$t('ti_shi'), {
        confirmButtonText: this.$t('que_ding'),
        cancelButtonText: this.$t('qu_xiao'),
        type: 'warning'
      }).then(() => {
        let vue = this
        deviceSyncDrink({ uuid: vue.device.uuid }).then(res => {
          vue.showLoading = true
          setTimeout(function () {
            vue.showLoading = false
            vue.$message.success(this.$t('tong_bu_cheng_gong'))
          }, 2000)
        })


      }).catch(() => {

      })
    },
    fullPullDrinkSync() {
      this.$confirm(this.$t('ci_cao_zuo_jiang_quan_liang_la_qu_she_bei_yin_pin_pei_fang_zhi_yun_duan'), this.$t('ti_shi'), {
        confirmButtonText: this.$t('que_ding'),
        cancelButtonText: this.$t('qu_xiao'),
        type: 'warning'
      }).then(() => {
        let vue = this
        deviceDrinkMaterialFullPull({ uuid: vue.device.uuid }).then(res => {
          vue.showLoading = true
          setTimeout(function () {
            vue.showLoading = false
            vue.$message.success(this.$t('tong_bu_cheng_gong'))
          }, 10000)
        })


      }).catch(() => {

      })
    },

    fullPullDevice() {
      this.$confirm(this.$t('ci_cao_zuo_jiang_quan_liang_la_qu_she_bei_yin_pin_zhi_yun_duan'), this.$t('ti_shi'), {
        confirmButtonText: this.$t('que_ding'),
        cancelButtonText: this.$t('qu_xiao'),
        type: 'warning'
      }).then(() => {
        let vue = this
        deviceFullPull({ uuid: vue.device.uuid }).then(res => {
          vue.showLoading = true
          setTimeout(function () {
            vue.showLoading = false
            vue.$message.success(this.$t('tong_bu_cheng_gong'))
          }, 2000)
        })


      }).catch(() => {

      })
    }
  },
}
</script>

<style lang="scss">
.device-drinks {
  padding: $padding $t-padding;
  display: flex;
  flex-direction: column;

  .device-drink-info {
    margin-top: $padding;
    padding: $padding;
    border-radius: $padding-5;
    border: 1px dashed $border_th_color;

    .device-info {
      p {
        font-size: .8rem;
        margin-bottom: $padding-5;

        label {
          color: $f_sec_color;
          margin-right: $padding;
        }

        span {
          color: $f_sec_color;
        }

        .mini {
          display: inline-block;
          margin-left: $padding-3;
          font-size: .6rem;
        }
      }
    }

    .device-operate {
      text-align: center;
    }

    .btn {
      margin-bottom: $padding-5;

      .el-button {
        width: 8rem;
      }

      .warn {
        color: $btn_color;
        border-color: $btn_color;
        //color: $f_th_color;
      }

      .warn:hover {
        color: $f_th_color;
        background-color: $btn_color;
      }

      .error {
        // color: $f_th_color;
        color: $btn_sec_color;
        border-color: $btn_sec_color;
        //background-color: $btn_sec_color;
      }

      .error:hover {
        color: $f_th_color;
        background-color: $btn_sec_color;
      }
    }

  }

  .device-drink-data-list {
    margin-top: $padding;
    flex: 1;

    .drink-item-info {
      * {
        vertical-align: middle;
      }

      img {
        max-width: 4rem;
        margin-right: $padding-5;
      }
    }
  }

  .device-drink-delete {
    color: $btn_sec_color;
  }

  .device-drink-edit {
    color: $btn_color;
    display: inline-block;
    margin-right: $padding;
  }

  .content-wrapper {
    height: 90%;
  }

  .cup-dialog {}

  .check {
    height: 100%;

    .el-row {
      height: 100%;

      .el-col {
        height: 100%;

        .cup {
          margin-top: 2%;
          padding-top: 8%;
          padding-bottom: 5%;
        }

        .el-input-number__decrease,
        .el-input-number__increase {
          border-radius: 50%;
          border: none;
          width: 1rem;
        }

        .el-input-number__decrease {
          color: $f_color;
          background-color: transparent;
          border: 1px solid $f_color;
        }

        .el-input-number__increase {
          background-color: $f_color;
        }

        .el-input-number--mini {
          line-height: 1rem;
        }

        .coffee-config {
          margin-bottom: 10px;
        }

      }
    }
  }

  .drink-check {
    height: 90%;
  }

  .pagination {
    margin: $padding;
  }
}
</style>
